import idx from "idx"
// import { toLowerCaseIfExists } from "@jsUtils"

/**
 * transform - manipulate data from the graphql query
 * @param {object} contentfulCompanyPillars
 * @returns {object}
 */
function transform(contentfulCompanyPillars) {
  const pillars = contentfulCompanyPillars
    ? contentfulCompanyPillars.map(pillar => {
        return {
          id: idx(pillar, _ => _.id),
          headline: idx(pillar, _ => _.headline),
          description: idx(pillar, _ => _.description.description)
        }
      })
    : []
  return {
    pillars
  }
}

export default { transform }
